import React from 'react'
import { withRouter } from 'react-router-dom'
import { useSessionData } from '../../../../components/sessionContext'

// images
import notFound from './images/404.svg'
import networkError from './images/network.svg'
import badRequest from './images/bad-request.svg'

// styles
import './index.css'

// semantic-ui
import {
  Container,
  Header,
  Image,
  Segment
} from 'semantic-ui-react'

const NoMatchComponent = props => {
  return (
    <Container className='NoMatch'>
      <Header as='h3' attached='top'>404 - Not Found</Header>
      <Segment attached='bottom' style={{ textAlign: 'center' }}>
        <Image src={notFound} centered size='tiny' />
        We can't seem to find the page you're looking for.
        <br />
        <a className='linky' href='/'>Click here</a> to go back to the home page.
      </Segment>
    </Container>
  )
}

// with router support
const NoMatch = withRouter(NoMatchComponent)

const NetworkError = props => {
  // session
  const session = useSessionData()
  const refresh = () => {
    window.location.reload()
  }
  const logout = () => {
    session.logout()
    window.location.reload()
  }
  return (
    <Container className='NetworkError'>
      <Header as='h3' attached='top'>Network Error</Header>
      <Segment attached='bottom' style={{ textAlign: 'center' }}>
        <Image src={networkError} centered size='tiny' />
        Server is not responding. <span className='linky' onClick={refresh}>Click here</span> to try again.
      </Segment>
      <p style={{ textAlign: 'center' }}>
        <small>
          Still having problems?
          <br/>
          <span className='linky' onClick={logout}>Click</span> to clear your cache and reload the page.
        </small>
      </p>
    </Container>
  )
}

const BadRequestComponent = props => {
  // session
  const session = useSessionData()
  const refresh = () => {
    window.location.reload()
  }
  const logout = () => {
    session.logout()
    window.location.reload()
  }
  return (
    <Container className='BadRequest'>
      <Header as='h3' attached='top'>Bad Request</Header>
      <Segment attached='bottom' style={{ textAlign: 'center' }}>
        <Image src={badRequest} centered size='tiny' />
        The server was unable to process the request sent by the client due to invalid syntax. <span className='linky' onClick={refresh}>Click here</span> to try again.
      </Segment>
      <p style={{ textAlign: 'center' }}>
        <small>
          Still having problems?
          <br/>
          <span className='linky' onClick={logout}>Click</span> to clear your cache and reload the page.
        </small>
      </p>
    </Container>
  )
}

const BadRequest = withRouter(BadRequestComponent)

export { NoMatch, NetworkError, BadRequest }
